import React from 'react';
import useLangTranslation from '../../../customHooks/languageProvider';
import { useSelector } from 'react-redux';

const SetRulesDisableSupervison = ({ 
    enableSupervision, handleTimeSupervision, deviceSelected
}) => {
    const {
        getLangTranslation
    } = useLangTranslation();
    const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
    const { appLanguageId } = useSelector(({ misc }) => misc);
    const lang = AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find((item) => item?.id === appLanguageId);
     
    // console.log(enableSupervision)

    return (
        <span className={`form-check form-switch form-check-right align-self-center mb-0 ${lang?.isRTL === 1 ? 'me-auto' : 'ms-auto'}`}>
            <label
                className="form-check-label text-blue-800 fw-semibold"
                htmlFor="deviceTime"
            >
                {
                    enableSupervision ? (
                        getLangTranslation('SETRULE_DISABLE_SUPERVISION', 'Disable Supervision')
                    ) : (
                        getLangTranslation('SETRULE_ENABLE_SUPERVISION', 'Enable Supervision')
                    )
                }
            </label>
            <input
                className="form-check-input"
                id='deviceTime'
                type="checkbox"
                role="switch"
                name="ENABLE_TIME_SUPERVISION"
                checked={enableSupervision || false}
                onChange={(e) => handleTimeSupervision(e, deviceSelected)}
            />
        </span>
    )
}

export default SetRulesDisableSupervison